import { FC } from 'react'

import { R } from 'core/helpers'

import { BoxContent, ErrorBox, ErrorMessage, ErrorTitle, FallbackProps } from './defaultErrorBoundaries'

const DefaultErrorFallback: FC<FallbackProps> = ({ className, error }) => (
  <ErrorBox className={className} $type={R.isObject(error) && error.status === 403 ? 'warning' : 'error'}>
    <ErrorTitle>Something went wrong</ErrorTitle>
    <BoxContent>
      <ErrorMessage error={error} />
    </BoxContent>
  </ErrorBox>
)

export default DefaultErrorFallback
